"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
/**
 * The subscription create component.
 * @param user
 * @param channel
 * @param id
 * @returns {*}
 */
function Plan(_a) {
    var user = _a.user, id = _a.id, status = _a.status;
    var plan = ra_fetch_1.useApi('ecommerce').show('plans', { id: id, type: 'users' })[0];
    var _b = react_1.useState(ra_fetch_1.Fetcher.model()), channel = _b[0], setChannel = _b[1];
    react_1.useEffect(function () {
        if (plan.data.channel_id) {
            ra_fetch_1.Fetcher.api('backend')
                .show('channels', { id: plan.data.channel_id, details: true })
                .then(function (response) { return setChannel(response); });
        }
    }, [plan.data.channel_id]);
    if (plan.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!plan.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'mx-auto' },
        react_1.default.createElement("div", { className: 'storybook-subscriptions-create' },
            react_1.default.createElement(storybook_1.Subscriptions.Info, { channel: channel.data }),
            react_1.default.createElement(storybook_1.Subscriptions.Form, { channel: channel.data, user: user, plan: plan.data, status: status })));
}
exports.default = Plan;
Plan.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    status: prop_types_1.default.string,
    id: prop_types_1.default.number.isRequired,
};
